import React from 'react';
import { connect } from 'react-redux';
import fetch from '../hooks/fetch';
import SearchBanner from './SearchBanner';
import SearchResults from './SearchResults';
import SearchInput from './SearchInput';
import SearchInfo from '../components/SearchInfo';
import FacetSidebar from './FacetSidebar';
import SearchPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/SearchPanelContainer';

const SearchPanelNarrow = ({
  canRun,
  category,
  code,
  description,
  exists,
  fetchData,
  fetchSearch,
  fetchSearchConfig,
  filtersVisible,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  search,
  searchConfigStatus,
  url,
}) => {
  fetch.useSearch(
    fetchData,
    fetchSearchConfig,
    fetchSearch,
    category,
    code,
    readStatus,
    searchConfigStatus,
    search,
    isNew,
  );

  return (
    <SearchPanelContainer
      canRun={canRun}
      category={category}
      code={code}
      description={description}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-search-panel-narrow">
        <div className="sticky-panel-header">
          <SearchInput code={code} category={category} compact />
          <SearchInfo />
          <SearchBanner code={code} category={category} />
        </div>
        {filtersVisible && <FacetSidebar code={code} category={category} />}
        {!filtersVisible && <SearchResults code={code} category={category} compact />}
      </div>
    </SearchPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPanelNarrow);
